export const TABLE_COL_WIDTH = 336;
export const TABLE_FIRST_COL_WIDTH = 236;
export const TABLE_LEFT_GAP = 20;
export const TABLE_PHOTOS_TITLE = 'Фото';
